import classNames from 'classnames';
import * as React from 'react';
import { Link } from '../../../Link/Link';
import {
    buildAbsoluteUrlWithQueryParameters,
    useQueryParametersObserver,
} from '../../../SearchBase/QueryParameterUtils';
import type { IconName } from '../../../SvgIcon/SvgIcon';
import { SvgIcon } from '../../../SvgIcon/SvgIcon';
import type { LanguagePickerProps } from '~/Features/Navigation/LanguagePickerProps';
import { LinkType } from '~/Partials/Link/LinkType.csharp';
import styles from './LanguagesPicker.module.css';

const getIconName = (languageCode: string): IconName => {
    switch (languageCode) {
        case 'en':
        case 'no':
            return languageCode;
        default:
            throw new Error(`Language code ${languageCode} could not be mapped to an icon.`);
    }
};

export const LanguagesPicker: React.FC<React.PropsWithChildren<LanguagePickerProps>> = props => {
    const { languages } = props;
    const languageEntries = [];

    const additionalQueryParams = useQueryParametersObserver();

    for (let i = 0; i < languages.length; i++) {
        languageEntries.push(
            <li key={i} className={classNames(styles.ListItem, i === 0 && styles['ListItem--active'])}>
                <Link
                    className={styles.ItemLink}
                    href={buildAbsoluteUrlWithQueryParameters(languages[i].url, additionalQueryParams)}
                    lang={languages[i].code}
                    type={LinkType.Clear}
                >
                    <div className={styles.Content}>
                        <SvgIcon className={styles.ItemIcon} iconName={getIconName(languages[i].code)} />
                        <span className={styles.ItemName}>{languages[i].label}</span>
                    </div>
                </Link>
            </li>
        );
    }

    return <ul className={styles.List}>{languageEntries}</ul>;
};
